import deviceMenu from '@js/common/deviceMenu.js';
import { initFancybox } from '@js/common/fancyboxInit.js';
import initStickyHeader from '@js/common/stickyHeader.js';

// Initialize mobile device menu
deviceMenu();

// Initialize sticky header navigation
initStickyHeader();

/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
	// Initialize Fancybox for popup video modals
	initFancybox();
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

((_$) => {
	// Write code here
})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */
